import { deepCopy, isObject, isArray } from "./utils.js";


const isLog = false;

const log = (...args) => {
    isLog && console.log(...args)
}

/**
 * 构造函数
 * @param data 数据
 * @param type storage
 * @constructor
 */
function StorageConstruct(data = {}, type) {
    // @ts-ignore
    this._data = data;
    // @ts-ignore
    this._type = type;
}

/**
 * 缓存数据
 * @param key - 缓存key
 * @param value - 缓存的数据
 * @param options - 扩展字段
 * @param options.duration - 缓存的秒数
 */
StorageConstruct.prototype.set = function (key, value, options = { duration: null }) {
    log('set', key, value, options)
    if (!key) {
        console.error('storage/sessionStorage：set数据,key异常');
        return;
    }
    if (!isObject(options)) {
        console.error('storage/sessionStorage：set数据,扩展字段options异常，非对象类型');
        return;
    }
    return this.baseStorage(key, value, options);
};
/**
 * 从缓存取数据
 * @param key
 * @param options - 扩展字段
 */
StorageConstruct.prototype.get = function (key, options) {
    log('get', key)
    if (!key) {
        console.error('storage/sessionStorage：get数据,key异常');
        return
    }
    return deepCopy(this.baseStorage(key, '_null_', options));
};
/**
 * 清空缓存
 */
StorageConstruct.prototype.clear = function (options = { storage: true }) {
    try {
        // @ts-ignore
        options = { storage: true, ...options }
        log('clear')
        if (this._type === 'storage') {
            Object.keys(this._data).forEach(k => {
                options.storage && uni.removeStorageSync(k);
            });
        }
        this._data = {};
    } catch (e) {
        console.log(e);
    }
};

/**
 * 删除单个key
 * @param key
 * @param options
 */
StorageConstruct.prototype._removeSingle = function (key, options = { storage: true }) {
    try {
        // @ts-ignore
        options = { storage: true, ...options }
        log('_removeSingle', key)
        delete this._data[key];
        options.storage && uni.removeStorageSync(key);
    } catch (e) {
        console.error(e)
    }
};

/**
 * 删除对应key的缓存数据
 * @param key
 * @param options
 */
StorageConstruct.prototype.remove = function (key, options = { storage: true }) {
    try {
        log('remove', key)
        if (!isArray(key)) {
            if (!key) {
                return;
            }
            this._removeSingle(key, options);
            return;
        }
        // @ts-ignore
        key.forEach((k) => {
            if (!k) {
                return;
            }
            this._removeSingle(k, options);
        });
    } catch (e) {
        console.log(e);
    }
};
/**
 *
 * @param key
 * @param value 默认_null_
 * @param options
 */
StorageConstruct.prototype.baseStorage = function (key = '', value = '_null_', options = {
    duration: null,
    storage: true
}) {
    if (!this._data) this._data = {};
    // @ts-ignore
    options = { storage: true, ...options, }
    // 取值
    if (value === '_null_') {
        let result = '';
        let _value = '';
        if (this._data.hasOwnProperty(key)) {
            _value = this._data[key];
        }
        try {
            // @ts-ignore
            result = _value = _value || uni.getStorageSync(key) || '';
            if (!this._data.hasOwnProperty(key)) {
                this._data[key] = _value;
            }
            // 走判断时间逻辑
            // @ts-ignore
            if (isObject(_value) && _value.duration) {
                let currTime = new Date().getTime() / 1000;
                // @ts-ignore
                if (currTime >= _value.duration) {
                    delete this._data[key];
                    uni.removeStorageSync(key);
                    result = ''
                } else {
                    // @ts-ignore
                    result = _value[key];
                }
            }
        } catch (e) {
            console.log(e);
        }
        return result;
    }
    // 存数据
    try {
        // 当没有设置时间,直接存
        if (!options.duration) {
            this._data[key] = value;
            if (this._type === 'storage') {
                // @ts-ignore
                options.storage && uni.setStorage({ key, data: value });
            }
            return;
        }
        // 设置了缓存时间
        let obj = {
            duration: undefined
        };
        // @ts-ignore
        obj[key] = value;
        //  在 duration 时间过期,传进来的是秒,例如 保存 30s
        // @ts-ignore
        obj.duration = Math.ceil(new Date().getTime() / 1000 + options.duration * 1);
        if (this._type === 'storage') {
            // @ts-ignore
            options.storage && uni.setStorage({ key, data: obj });
        }
        this._data[key] = obj;
    } catch (e) {
        console.log('缓存失败', e);
    }
};

let _storageData = {};
let _sessionStorageData = {};
// @ts-ignore
export var storage = new StorageConstruct(_storageData, 'storage');
// @ts-ignore
export var sessionStorage = new StorageConstruct(_sessionStorageData, 'sessionStorage');
export default {
    storage: storage,
    sessionStorage: sessionStorage
};
